package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import org.zest.insan_360_website.pages.LoginState

object LoginPageState {
    var loginState by mutableStateOf(LoginState())

    fun reset() {
        loginState = LoginState()
    }
}